import { Link } from "react-router-dom";
import { StackedLogo } from "@/components/StackedLogo";
import { resetCookieConsent } from "@/components/CookieConsent";

export function LegalPageChrome({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <nav className="fixed top-0 z-50 w-full bg-background/95 backdrop-blur-sm border-b border-border px-4 md:px-6">
        <div className="mx-auto flex h-[56px] max-w-[1200px] items-center">
          <Link to="/" className="flex items-center -ml-0.5">
            <StackedLogo size={14} />
          </Link>
        </div>
      </nav>

      {children}

      <footer className="border-t border-border">
        <div className="mx-auto max-w-[1200px] px-4 md:px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <StackedLogo size={16} />
          <div className="flex flex-col md:flex-row items-center gap-3 md:gap-4">
            <div className="flex items-center gap-4">
              <Link to="/terms" className="text-[12px] text-muted-foreground hover:text-foreground transition-colors">
                Terms
              </Link>
              <Link to="/privacy" className="text-[12px] text-muted-foreground hover:text-foreground transition-colors">
                Privacy
              </Link>
              <button
                onClick={resetCookieConsent}
                className="text-[12px] text-muted-foreground hover:text-foreground transition-colors"
              >
                Cookie settings
              </button>
            </div>
            <span className="text-[12px] text-muted-foreground text-center">
              © 2026 CAIRE. All rights reserved.
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}
